import React from "react";
import { Container, Grid, Stack, Text, Title, Image } from "@mantine/core";
import { useEffect, useState } from "react";
import { set } from "lodash";
import { useViewportSize } from "@mantine/hooks";
import {
    APIProvider,
    Map,
    useMapsLibrary,
    useMap,
    AdvancedMarker,
    Pin,
} from "@vis.gl/react-google-maps";

export default function GoogleMap(props) {
    const [tour, setTour] = useState(null);
    const [markers, setMarkers] = useState([]);
    useEffect(() => {
        setTour(props.tour);
    }, []);

    const MyComponent = (props) => {
        const geometryLibrary = useMapsLibrary("geometry");
        const mapsLibrary = useMapsLibrary("maps");
        const coreLibrary = useMapsLibrary("core");
        const markerLibrary = useMapsLibrary("marker");
        const map = useMap("1e048001d302cdb2");

        const [geometryService, setGeometryService] = useState(null);
        useEffect(() => {
            if (!geometryLibrary) return;
            // when geometryLibrary is loaded, the library can be accessed via the
            // geometryLibrary API object
            setGeometryService(geometryLibrary);
        }, []);

        useEffect(() => {
            if (!geometryService) return;
            let bounds = [];
            let marker_array = [];
            let map_bounds = new coreLibrary.LatLngBounds();
            // console.log(props.tour);
            props.tour.map((day, index) => {
                var path = geometryService.encoding.decodePath(day.polyline);
                // console.log(mapsLibrary);
                bounds[index] = new coreLibrary.LatLngBounds();
                // //console.log(path);
                for (var i = 0; i < path.length; i++) {
                    bounds[index].extend(path[i]);
                    map_bounds.extend(path[i]);
                }
                // day.stops.map((stop, index) => {
                //     let latlng = new coreLibrary.LatLng(stop.lat, stop.lng);
                //     // new markerLibrary.Marker({
                //     //     position: latlng,
                //     //     map: map,
                //     // icon: {
                //     //     url: stop.icon,
                //     //     scaledSize: new mapsLibrary.Size(50, 50),
                //     // },
                //     // });

                //     new markerLibrary.AdvancedMarkerElement({
                //         position: latlng,
                //         map: map,
                //         // icon: {
                //         //     url: stop.icon,
                //         // scaledSize: new mapsLibrary.Size(50, 50),
                //         // },
                //     });

                //     // marker_array.push(
                //     // return (
                //     //     <AdvancedMarker
                //     //         key={stop.id + index}
                //     //         position={{ lat: stop.lat, lng: stop.lng }}
                //     //         map={map}
                //     //     >
                //     //         <Pin
                //     //             background={"#80d3e5"}
                //     //             glyphColor={"#000"}
                //     //             borderColor={"#000"}
                //     //         />
                //     //     </AdvancedMarker>
                //     // );
                //     // );
                // });

                const iconBase =
                    "https://developers.google.com/maps/documentation/javascript/examples/full/images/";
                const icons = {
                    parking: {
                        icon: iconBase + "parking_lot_maps.png",
                    },
                    library: {
                        icon: iconBase + "library_maps.png",
                    },
                    info: {
                        icon: iconBase + "info-i_maps.png",
                    },
                };
                const features = [
                    {
                        position: new google.maps.LatLng(-33.91721, 151.2263),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91539, 151.2282),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91747, 151.22912),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.9191, 151.22907),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91725, 151.23011),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91872, 151.23089),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91784, 151.23094),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91682, 151.23149),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.9179, 151.23463),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.91666, 151.23468),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(-33.916988, 151.23364),
                        type: "info",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.91662347903106,
                            151.22879464019775,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.916365282092855,
                            151.22937399734496,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.91665018901448,
                            151.2282474695587,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.919543720969806,
                            151.23112279762267,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.91608037421864,
                            151.23288232673644,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.91851096391805,
                            151.2344058214569,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.91818154739766,
                            151.2346203981781,
                        ),
                        type: "parking",
                    },
                    {
                        position: new google.maps.LatLng(
                            -33.91727341958453,
                            151.23348314155578,
                        ),
                        type: "library",
                    },
                ];
                console.log(map);
                for (let i = 0; i < features.length; i++) {
                    const iconImage = document.createElement("img");

                    iconImage.src = icons[features[i].type].icon;

                    const marker = new google.maps.marker.AdvancedMarkerElement(
                        {
                            map,
                            position: features[i].position,
                            content: iconImage,
                        },
                    );
                }

                new mapsLibrary.Polyline({
                    path: path,
                    geodesic: true,
                    strokeColor: "#FFFFFF",
                    strokeOpacity: 1.0,
                    strokeWeight: 5,
                    map: map,
                });
            });
            setMarkers(markers);
            if (bounds.length > 0) {
                map.fitBounds(map_bounds);
            }
        }, [geometryService]);
    };
    return (
        <APIProvider
            apiKey={"AIzaSyBcgKpMmNrQM-HejUU3lgB6ej0j__aje2Y"}
            // libraries={["geometry"]}
            // onLoad={buildPolyLine(tour)}
        >
            <div style={{ width: "100%", height: "100%" }}>
                <Map
                    id="1e048001d302cdb2"
                    mapId={"1e048001d302cdb2"}
                    zoom={6}
                    center={{ lat: 56.8969366, lng: -4.7444853 }}
                    gestureHandling={"greedy"}
                    disableDefaultUI={true}
                    styles={[
                        {
                            featureType: "administrative",
                            elementType: "all",
                            stylers: [
                                { visibility: "on" },
                                { color: "#333333" },
                            ],
                        },
                        {
                            featureType: "administrative",
                            elementType: "labels.text.stroke",
                            stylers: [{ color: "#ffffff" }, { weight: 2 }],
                        },
                        {
                            featureType: "administrative.country",
                            elementType: "geometry",
                            stylers: [
                                { visibility: "on" },
                                { color: "#5d325e" },
                            ],
                        },
                        {
                            featureType: "administrative.country",
                            elementType: "geometry.fill",
                            stylers: [
                                { visibility: "off" },
                                { saturation: "71" },
                                { lightness: "-100" },
                            ],
                        },
                        {
                            featureType: "administrative.country",
                            elementType: "geometry.stroke",
                            stylers: [
                                { visibility: "on" },
                                { color: "#5d325e" },
                            ],
                        },
                        {
                            featureType: "administrative.country",
                            elementType: "labels",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            featureType: "landscape",
                            elementType: "all",
                            stylers: [
                                { visibility: "off" },
                                { color: "#ff0000" },
                            ],
                        },
                        {
                            featureType: "landscape.natural",
                            elementType: "all",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            featureType: "landscape.natural",
                            elementType: "geometry.fill",
                            stylers: [
                                { visibility: "on" },
                                { color: "#c7c9c6" },
                            ],
                        },
                        {
                            featureType: "landscape.natural.landcover",
                            elementType: "all",
                            stylers: [{ color: "#8e3030" }],
                        },
                        {
                            featureType: "landscape.natural.landcover",
                            elementType: "geometry.fill",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            featureType: "poi",
                            elementType: "all",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            featureType: "road",
                            elementType: "all",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            featureType: "transit",
                            elementType: "all",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            featureType: "water",
                            elementType: "all",
                            stylers: [
                                { visibility: "on" },
                                { color: "#5d325e" },
                            ],
                        },
                    ]}
                >
                    {/* {markers} */}
                </Map>
                <MyComponent tour={tour} />
            </div>
        </APIProvider>
    );
}
